<template>
  <div style="line-height: 100%" @click="toggleMode">
    <span class="fs-12 assist-hover" v-if="item.des" :style="desStyle">{{
        item.des
      }}</span>
    <el-tooltip
        effect="dark"
        v-if="item.hoverTitle"
        :content="
        item.hoverCode
          ? `${item.hoverCode}: ${item.hoverTitle}`
          : item.hoverTitle
      "
        placement="top"
    >
      <div>
        <template v-if="themeCfg?.iconSet?.arrowPosition === 'left'">
          <span
              class="color mr-4"
              :style="{
              width: `${option.assistUnitFontSize || 12}px`,
              height: `${option.assistUnitFontSize || 12}px`,
              display: 'inline-block',
              verticalAlign: 'bottom',
              color:
                arrowConfig?.color || (item.value > 0 ? '#E84B45' : '#39ACAA'),
            }"
              :class="
              !item?.metricStyleCondition ? (item.value > 0 ? 'gre' : 'r1') : ''
            "
              v-if="item.showMark && 'value' in item"
          >
            <template
                v-if="
                arrowConfig?.iconType === 'up' ||
                (!item?.metricStyleCondition && item.value > 0)
              "
            >
              <span v-if="themeCfg?.iconSet?.upImage" v-html="upSvgStr"></span>
              <svg
                  v-else
                  style="width: 100%; height: 100%"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 17 17"
                  class="design-iconfont"
              >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.25879 1.66675L14.7588 9.07782L11.1487 8.23494L11.0907 8.26075L11.0457 8.60629C10.5256 12.0791 8.36967 14.849 5.5952 15.6667C6.47777 14.3447 6.82335 13.994 7.14396 12.1147C7.3577 10.8619 7.45525 9.57586 7.4366 8.25659L7.53375 8.2555L7.4896 8.23494L3.75879 9.07782L9.25879 1.66675Z"
                    fill="currentColor"
                />
              </svg>
            </template>
            <template
                v-if="
                arrowConfig?.iconType === 'down' ||
                (!item?.metricStyleCondition && item.value < 0)
              "
            >
              <span
                  v-if="themeCfg?.iconSet?.downImage"
                  v-html="downSvgStr"
              ></span>
              <svg
                  v-else
                  style="width: 100%; height: 100%"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 17 17"
                  class="design-iconfont"
              >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.21875 15.6667L3.71875 8.25568L7.32885 9.09855L7.38686 9.07275L7.43181 8.72721C7.95196 5.25436 10.1079 2.48454 12.8823 1.66675C11.9998 2.98879 11.6542 3.33954 11.3336 5.21877C11.1198 6.47159 11.0223 7.75764 11.0409 9.07691L10.9438 9.078L10.9879 9.09856L14.7188 8.25568L9.21875 15.6667Z"
                    fill="currentColor"
                />
              </svg>
            </template>
          </span>
        </template>
        <span class="assist-value" :style="getVColor(item)">
          {{ getValue("value" in item ? item.value : "--") }}
          <template
              v-if="
              themeCfg?.iconSet?.arrowPosition === 'right' ||
              !themeCfg?.iconSet?.arrowPosition
            "
          >
            <span
                class="color"
                :style="{
                width: `${option.assistUnitFontSize || 12}px`,
                height: `${option.assistUnitFontSize || 12}px`,
                display: 'inline-block',
                verticalAlign: 'bottom',
                color:
                  arrowConfig?.color ||
                  (item.value > 0 ? '#E84B45' : '#39ACAA'),
              }"
                :class="
                !item?.metricStyleCondition
                  ? item.value > 0
                    ? 'gre'
                    : 'r1'
                  : ''
              "
                v-if="item.showMark && 'value' in item"
            >
              <!-- !item?.set?.metricStyleCondition 兼容老的逻辑红正绿负 -->
              <template
                  v-if="
                  arrowConfig?.iconType === 'up' ||
                  (!item?.metricStyleCondition && item.value > 0)
                "
              >
                <span
                    v-if="themeCfg?.iconSet?.upImage"
                    v-html="upSvgStr"
                ></span>
                <svg
                    v-else
                    style="width: 100%; height: 100%"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 17 17"
                    class="design-iconfont"
                >
                  <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.25879 1.66675L14.7588 9.07782L11.1487 8.23494L11.0907 8.26075L11.0457 8.60629C10.5256 12.0791 8.36967 14.849 5.5952 15.6667C6.47777 14.3447 6.82335 13.994 7.14396 12.1147C7.3577 10.8619 7.45525 9.57586 7.4366 8.25659L7.53375 8.2555L7.4896 8.23494L3.75879 9.07782L9.25879 1.66675Z"
                      fill="currentColor"
                  />
                </svg>
              </template>
              <template
                  v-if="
                  arrowConfig?.iconType === 'down' ||
                  (!item?.metricStyleCondition && item.value < 0)
                "
              >
                <span
                    v-if="themeCfg?.iconSet?.downImage"
                    v-html="downSvgStr"
                ></span>
                <svg
                    v-else
                    style="width: 100%; height: 100%"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 17 17"
                    class="design-iconfont"
                >
                  <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.21875 15.6667L3.71875 8.25568L7.32885 9.09855L7.38686 9.07275L7.43181 8.72721C7.95196 5.25436 10.1079 2.48454 12.8823 1.66675C11.9998 2.98879 11.6542 3.33954 11.3336 5.21877C11.1198 6.47159 11.0223 7.75764 11.0409 9.07691L10.9438 9.078L10.9879 9.09856L14.7188 8.25568L9.21875 15.6667Z"
                      fill="currentColor"
                  />
                </svg>
              </template>
            </span>
          </template>
        </span>
      </div>
    </el-tooltip>
    <span v-else class="assist-value" :style="getVColor(item)">
      <template v-if="themeCfg?.iconSet?.arrowPosition === 'left'">
        <span
            class="color mr-4"
            :style="{
            width: `${option.assistUnitFontSize || 12}px`,
            height: `${option.assistUnitFontSize || 12}px`,
            display: 'inline-block',
            verticalAlign: 'bottom',
            color:
              arrowConfig?.color || (item.value > 0 ? '#E84B45' : '#39ACAA'),
          }"
            :class="
            !item?.metricStyleCondition ? (item.value > 0 ? 'gre' : 'r1') : ''
          "
            v-if="item.showMark && 'value' in item"
        >
          <template
              v-if="
              arrowConfig?.iconType === 'up' ||
              (!item?.metricStyleCondition && item.value > 0)
            "
          >
            <span v-if="themeCfg?.iconSet?.upImage" v-html="upSvgStr"></span>
            <svg
                v-else
                style="width: 100%; height: 100%"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 17 17"
                class="design-iconfont"
            >
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.25879 1.66675L14.7588 9.07782L11.1487 8.23494L11.0907 8.26075L11.0457 8.60629C10.5256 12.0791 8.36967 14.849 5.5952 15.6667C6.47777 14.3447 6.82335 13.994 7.14396 12.1147C7.3577 10.8619 7.45525 9.57586 7.4366 8.25659L7.53375 8.2555L7.4896 8.23494L3.75879 9.07782L9.25879 1.66675Z"
                  fill="currentColor"
              />
            </svg>
          </template>
          <template
              v-if="
              arrowConfig?.iconType === 'down' ||
              (!item?.metricStyleCondition && item.value < 0)
            "
          >
            <span
                v-if="themeCfg?.iconSet?.downImage"
                v-html="downSvgStr"
            ></span>
            <svg
                v-else
                style="width: 100%; height: 100%"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 17 17"
                class="design-iconfont"
            >
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.21875 15.6667L3.71875 8.25568L7.32885 9.09855L7.38686 9.07275L7.43181 8.72721C7.95196 5.25436 10.1079 2.48454 12.8823 1.66675C11.9998 2.98879 11.6542 3.33954 11.3336 5.21877C11.1198 6.47159 11.0223 7.75764 11.0409 9.07691L10.9438 9.078L10.9879 9.09856L14.7188 8.25568L9.21875 15.6667Z"
                  fill="currentColor"
              />
            </svg>
          </template>
        </span>
      </template>
      {{ getValue("value" in item ? item.value : "--") }}
      <span :style="getUnitStyle(item)">
        {{ assistUnit }}
      </span>

      <template
          v-if="
          themeCfg?.iconSet?.arrowPosition === 'right' ||
          !themeCfg?.iconSet?.arrowPosition
        "
      >
        <span
            class="color"
            :style="{
            width: `${option.assistUnitFontSize || 12}px`,
            height: `${option.assistUnitFontSize || 12}px`,
            display: 'inline-block',
            verticalAlign: 'bottom',
            color:
              arrowConfig?.color || (item.value > 0 ? '#E84B45' : '#39ACAA'),
          }"
            :class="
            !item?.metricStyleCondition ? (item.value > 0 ? 'gre' : 'r1') : ''
          "
            v-if="item.showMark && 'value' in item"
        >
          <!-- !item?.set?.metricStyleCondition 兼容老的逻辑红正绿负 -->
          <template
              v-if="
              arrowConfig?.iconType === 'up' ||
              (!item?.metricStyleCondition && item.value > 0)
            "
          >
            <span v-if="themeCfg?.iconSet?.upImage" v-html="upSvgStr"></span>
            <svg
                v-else
                style="width: 100%; height: 100%"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 17 17"
                class="design-iconfont"
            >
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.25879 1.66675L14.7588 9.07782L11.1487 8.23494L11.0907 8.26075L11.0457 8.60629C10.5256 12.0791 8.36967 14.849 5.5952 15.6667C6.47777 14.3447 6.82335 13.994 7.14396 12.1147C7.3577 10.8619 7.45525 9.57586 7.4366 8.25659L7.53375 8.2555L7.4896 8.23494L3.75879 9.07782L9.25879 1.66675Z"
                  fill="currentColor"
              />
            </svg>
          </template>
          <template
              v-if="
              arrowConfig?.iconType === 'down' ||
              (!item?.metricStyleCondition && item.value < 0)
            "
          >
            <span
                v-if="themeCfg?.iconSet?.downImage"
                v-html="downSvgStr"
            ></span>
            <svg
                v-else
                style="width: 100%; height: 100%"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 17 17"
                class="design-iconfont"
            >
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.21875 15.6667L3.71875 8.25568L7.32885 9.09855L7.38686 9.07275L7.43181 8.72721C7.95196 5.25436 10.1079 2.48454 12.8823 1.66675C11.9998 2.98879 11.6542 3.33954 11.3336 5.21877C11.1198 6.47159 11.0223 7.75764 11.0409 9.07691L10.9438 9.078L10.9879 9.09856L14.7188 8.25568L9.21875 15.6667Z"
                  fill="currentColor"
              />
            </svg>
          </template>
        </span>
      </template>
    </span>
  </div>
</template>
<script setup>
import {Top, Bottom} from "@element-plus/icons-vue";
import {computed, onMounted, ref, watch} from "vue";
import util from "@/option/common/util";

let props = defineProps({
  item: {},
  option: {},
  upSvgStr: {},
  downSvgStr: {},
  themeCfg: {},
  presentMode: {},
  assistMetrics: {
    type: Array,
    default: () => [],
  },
});
const emit = defineEmits(['update:presentMode'])

function toggleMode() {
  emit('update:presentMode', false)
}

// 暂时去掉这里的格式化 走统一格式化配置处理
// watchEffect(() => {
//   if ("value" in props.item && typeof props.item.value === 'number') {
//     props.item.value = props.item.value.toFixed(2)
//   }
// })

let desStyle = computed(() => {
  return {
    color: props.option.assistDesColor,
    fontSize: props.option.assistDesFontSize + "px",
    lineHeight: "100%",
  };
});
let assistValue = computed(() => {
  return {
    color: props.option.assistColor,
    fontSize: props.option.assistFontSize + "px",
    lineHeight: "100%",
  };
});

// 显示辅助指标单位
let assistUnit = computed(() => {
  return (
      props.assistMetrics.find(
          (metItem) => props.item.indexField === metItem.code
      ) || {}
  ).set?.indexUnit;
});

let arrowConfig = ref({});

function getVColor(item) {
  return {
    ...assistValue.value,
    color:
        props.option.assistColor ||
        (item.showMark && "value" in item
            ? arrowConfig.value?.color || (item.value > 0 ? "#E84B45" : "#39ACAA")
            : ""),
  };
}

function getValue(v) {
  return props.presentMode ? '****' : v
}

function getUnitStyle(item, index) {
  return {
    fontSize: `${props.option.assistUnitFontSize}px`,
    fontWeight: props.option.assistUnitWeight,
    color:
        props.option.assistUnitColor ||
        (item.showMark && "value" in item
            ? arrowConfig.value?.color || (item.value > 0 ? "#E84B45" : "#39ACAA")
            : ""),
  };
}

const calcArrowConfig = async (item) => {
  let matchItem = null;
  if (item?.metricStyleCondition) {
    let promiseList = [];
    item?.metricStyleCondition.forEach((ruleItem) => {
      promiseList.push(
          util.parseMetricCardRule(
              ruleItem.conditions,
              {...item, code: item.indexField},
              (type) => {
                if (type === "match") {
                  matchItem = {
                    code: item.indexField,
                    color: ruleItem.color,
                    iconType: ruleItem.iconType,
                  };
                }
              }
          )
      );
    });
    await Promise.all(promiseList);
  }
  return matchItem;
};

watch(
    () => props.item,
    async () => {
      arrowConfig.value = await calcArrowConfig(props.item);
    }
);
</script>

<style scoped lang="scss">
.assist-hover {
  color: #1f3858;
  margin-right: 8px;
}
</style>
